import orderingInfo1 from '../../../../shared/images/ordering-info-1.jpg';
import orderingInfo2 from '../../../../shared/images/ordering-info-2.jpg';
import orderingInfo3 from '../../../../shared/images/ordering-info-3.jpg';
import reset from '../../../../shared/images/Reset.jpg';

/**
 * Content for the new ordering Examples modal
 * Used with OnboardingModal component
 */
const orderingInfoContent = [
  {
    image: orderingInfo1,
    title: 'Refreshed Reordering Functionality',
    description: '',
    gradientType: 'primary',
  },
  {
    image: orderingInfo2,
    title: 'Refreshed Reordering Functionality',
    description:
      'Building items on the parent calendar will always appear at the top until you make an edit on the sub or athlete level calendar that triggers an override in appearance. In this example, you build 2 items on the parent, add 1 item to the athlete calendar and then make the move to bring the athlete item to the top for that athlete to focus on. Only that athlete will see anything different in their workout compared to others assigned to the parent calendar. Making customization more intentional.',
    gradientType: 'primary',
  },
  {
    image: orderingInfo3,
    title: 'Refreshed Reordering Functionality',
    description:
      'In the example above, you built out two main exercises for Baseball, two main exercises for pitchers and added 2 more for a particular athlete (Rocky). You go into the pitchers sub calendar and move Exercise 3 above 2, because the pitchers need access to certain equipment before another group. You then go down one more level to an athlete and remove exercise 4 from their Sub calendar inheritance because they cant perform that exercise. The final workout will be shown to them on the right hand side.',
    gradientType: 'primary',
  },
  {
    image: reset,
    title: 'Refreshed Reordering Functionality',
    description:
      'Reseting the order will arrange items to the default - inheritance based order. Parent calendar items at top, sub calendar in the middle, athlete at the bottom. You can still make edits after resetting order that will then reflect back to the athlete following our ruleset.',
    gradientType: 'primary',
  },
];

export default orderingInfoContent;
